import { cn } from '@/utils/cn'
import { type IconProps, iconVariants } from './common'

export function CopyIcon({ className, size = 16, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M15.7631 8.75H13C11.3431 8.75 10 10.0931 10 11.75V17.75C10 19.4069 11.3431 20.75 13 20.75H17C18.6569 20.75 20 19.4069 20 17.75V13.1931C20 12.477 19.7438 11.7845 19.2778 11.2407L18.0408 9.79763C17.4709 9.13269 16.6388 8.75 15.7631 8.75Z"
        fill="currentColor"
      />
      <path
        d="M9.76305 4.75H7C5.34315 4.75 4 6.09315 4 7.75V13.75C4 15.4069 5.34315 16.75 7 16.75H8.5V11.25C8.5 9.04086 10.2909 7.25 12.5 7.25H13.2857C13.2831 7.24691 13.2804 7.24382 13.2778 7.24073L12.0408 5.79763C11.4709 5.13269 10.6388 4.75 9.76305 4.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
